import * as types from "../constants/actionTypes";
import initialstate from "./initialState";

export default (state = initialstate.viewDirection, action) => {
  switch (action.type) {
    case types.CHANGE_VIEW_DIRECTION:
      return action.payload;

    case types.CHANGE_LANG: {
      const { payload = "" } = action;
      let direction = initialstate.viewDirection;
      if (payload.toLowerCase() === "heb") {
        direction = "rtl";
      }
      return direction;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/viewDirectionReducer.js